import React, { useState } from 'react';

export default function LegalPage() {
  const [activeTab, setActiveTab] = useState('Terms');

  const termsContent = `A&W PRESSURE WASHING & CLEANING - TERMS & CONDITIONS
Last updated: August 5, 2026

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1) PARTIES & ACCEPTANCE

1.1 These Terms & Conditions form a binding agreement between A & W Pressure Washing & Cleaning and the Client (property owner or authorized agent).

1.2 Client accepts these Terms by: (a) signing a quote/work order; (b) paying a deposit or invoice; (c) responding "approve/yes" in writing; or (d) permitting work to begin.

1.3 Entire Agreement. These Terms plus our written Quote/Scope of Work (SOW), any Change Orders, and our Privacy Policy form the entire agreement and supersede prior communications.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

2) SCOPE OF SERVICES

2.1 Services include: house/building wash (soft wash), roof treatment, concrete cleaning, patios/decks/fences, gutters, awnings, signage, parking lots, and sanitation of specified surfaces.

2.2 Methods may include soft-wash, pressure cleaning, detergents, and specialty chemistry.

2.3 Exclusions: stain/seal, painting, mortar/caulk repair, window detailing, and post-construction cleanup (unless listed in SOW).

2.4 Permanent stains, artillery fungus, battery/rust burns, deep oil, and oxidation are often not fully correctable without add-on services.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

3) SCHEDULING, ACCESS & SITE PREPARATION

3.1 Dates are estimates and weather-dependent. We may adjust for rain, lightning, wind, or unsafe conditions.

3.2 Client must provide clear, safe access to water spigots, electrical outlets, gates, and service areas. Dogs/pets must be secured away.

3.3 Preparation Checklist (Client Responsibility):
   • Close/lock all windows/doors
   • Move vehicles off cleaning zones
   • Remove or cover cushions, mats, fabrics, potted plants, and electronics
   • Identify leaks, defective gutters, and sensitive materials
   • Provide disclosure of known hazards

3.4 Trip/Standby Fees: If access prevents work, a $65 trip fee or 20% of job (whichever greater) may apply.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

4) WATER, UTILITIES & ENVIRONMENTAL PRACTICES

4.1 Client authorizes use of on-site water and ensures spigots are functional.

4.2 We follow Best Management Practices to limit overspray. Normal wash water may contact soil/landscaping and exterior drains.

4.3 We pre-wet adjacent plants when using active solutions. DESPITE PRECAUTIONS, temporary plant stress or spotting CAN OCCUR.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

5) SURFACE & MATERIAL RISKS (ACKNOWLEDGMENT)

5.1 Oxidation & Tiger-Striping: Aged vinyl/aluminum can streak when washed. Full oxidation removal is NOT standard cleaning.

5.2 Weep Holes/Window Seals: Older window seals may allow minor intrusion. We are not responsible for pre-existing seal failures.

5.3 Wood: Pressure can raise grain; weathered wood may shed fibers.

5.4 Concrete/Flatwork: "Shadowing" or "wand marks" can appear on heavily soiled slabs. Oil/rust burns may remain.

5.5 Roofing: SOFT-WASH ONLY (no high pressure). Granule loss is age-related.

5.6 Delicate Materials: Loose mortar, failing stucco, oxidized paint, and degraded sealants can fail under normal rinsing.

Client acknowledges these inherent risks and authorizes industry-standard methods.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

6) ESTIMATES, PRICING & CHANGES

6.1 Written estimates valid for 7 business days from the date of the written estimate unless noted.

6.2 Change Orders: Hidden conditions or extra areas require WRITTEN approval and may adjust price/time.

6.3 Minimum Charge: A minimum service charge may apply.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

7) DEPOSITS, PAYMENT & FEES

7.1 Deposit: Up to 30% to schedule, credited to final invoice.

7.2 Payment Due: UPON COMPLETION unless otherwise agreed in writing.

7.3 Methods: Cash, card via Stripe, Cash App, or other approved methods.

7.4 Late Fees: Balances over 7 days past due accrue 1.5% per month (18% APR) or maximum allowed by law.

7.5 Chargebacks: Unauthorized chargebacks are a breach. Notify us and allow 10 business days to cure.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

8) CANCELLATIONS & RESCHEDULING

8.1 Client Cancellation:
   • >48 hours: no fee
   • 24-48 hours: $50 or 10% of job (whichever greater)
   • <24 hours or no access: $65 trip fee or 20% of job

8.2 Weather Delays: We may reschedule without penalty for safety/weather.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

9) WORKMANSHIP WARRANTY

9.1 Workmanship warranted for 7 days after service. Report concerns with photos within the window.

9.2 If we verify an area was missed or streaked by our process, we will re-clean at no cost.

9.3 Exclusions: Re-soiling, environmental fallout, sap, pollen, bird activity, or pre-existing damage.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

10) DAMAGE & LIMITATIONS OF LIABILITY

10.1 We are NOT responsible for pre-existing defects, prior poor workmanship, failing seals/paint, or concealed issues.

10.2 We are not liable for items left in work zones.

10.3 We are NOT liable for indirect, incidental, special, or consequential damages.

10.4 Cap on Liability: Our total liability is limited to the AMOUNT YOU PAID FOR THAT JOB in the preceding 6 months.

10.5 Client must promptly notify us of alleged damage. Failure may void claims.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

11) SAFETY

11.1 Keep children, pets, and bystanders away from hoses, chemicals, equipment, and wet surfaces.

11.2 Cleaned surfaces can be SLIPPERY WHEN WET. Client assumes responsibility to restrict traffic.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

12) PHOTOS, VIDEOS & MARKETING

12.1 We capture before/after media to document work and train staff.

12.2 With your consent, we may use de-identified photos/videos in portfolios, social media, or ads. You may revoke consent anytime by writing to us.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

13) GOVERNING LAW & DISPUTE RESOLUTION

These Terms are governed by TENNESSEE law. Exclusive venue lies in Warren County, TN courts.

Before suit, parties will attempt good faith resolution within 30 days of written notice.

The prevailing party may recover reasonable attorneys' fees and costs where allowed by law.

For questions: (931) 259-7963 or legal@awpressurewash.com`;

  const privacyContent = `A&W PRESSURE WASHING & CLEANING - PRIVACY POLICY
Last updated: August 5, 2026

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

QUICK VERSION
We collect only what we need to provide quotes, schedule services, take payments, and communicate with you. We never sell your personal information.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1) WHO WE ARE & HOW TO CONTACT US

Business: A & W Pressure Washing & Cleaning
Mailing Address: By email request only.
Email: legal@awpressurewash.com
Phone: (931) 259-7963

For privacy requests (access, deletion, correction, opt-out): Contact us above.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

2) PERSONAL INFORMATION WE COLLECT

2.1 Information You Provide:
   • Contact details: name, email, phone, address
   • Service details: property type, requested services, photos
   • Scheduling details: preferred dates/times, job notes
   • Payment info: If you pay online, Stripe processes your card (PCI-compliant). We do NOT store full card numbers.
   • Communications: emails, SMS, phone notes, chat messages
   • Consent records: email/SMS opt-in/out, cookie preferences

2.2 Information We Collect Automatically:
   • Device/technical data: IP address, browser type, OS, language, timestamps
   • Cookies & similar tech: for session management and functionality
   • Security/anti-fraud signals: rate-limiting, error logs

2.3 Information From Service Providers:
   • Payments: Stripe (transaction status, last 4 digits, card brand, amount)
   • Email/SMS: message status (sent/delivered/bounced)
   • Calendaring/booking: appointment confirmations/updates
   • Maps/Geocoding: Google Maps for service areas

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

3) HOW WE USE PERSONAL INFORMATION

   • Provide services: estimates, scheduling, invoicing, service delivery
   • Communicate: quotes, reminders, updates, support
   • Process payments: transactions, refunds, fraud prevention
   • Operations: website functionality, analytics, debugging
   • Safety & compliance: fraud detection, legal compliance, tax records
   • Marketing (optional): promotions, updates, review requests (with consent)

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

4) LEGAL BASES

   • Contract: to provide requested services
   • Legitimate interests: security, anti-fraud, service improvement
   • Consent: marketing emails/SMS, certain cookies
   • Legal obligation: tax, regulatory compliance

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

5) DISCLOSURES & THIRD PARTIES

We DO NOT SELL personal information. We disclose only as needed:

SERVICE PROVIDERS:
   • Payments: Stripe (card processing)
   • Communications: email/SMS providers
   • Calendaring/Forms: Google (Calendar, Sheets, Drive)
   • Hosting/CDN: Cloudflare

OPERATIONAL NEEDS:
   • Accountants, bookkeepers, legal counsel, insurers

BUSINESS TRANSFERS:
   • If A&W is merged, acquired, or sells assets

LEGAL:
   • To comply with valid law enforcement or court orders

WITH YOUR DIRECTION:
   • Sending estimates/invoices to your requested contacts

PAYMENT SECURITY:
Card data handled by Stripe under PCI-DSS compliance. We receive tokens and limited metadata—NOT full card numbers.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

6) DATA RETENTION

We keep Personal Information only as long as necessary:
   • Operational records: typically 7 years (tax/audit/bookkeeping)
   • Communications & scheduling: while active + reasonable time after
   • Marketing preferences: until opt-out
   • Logs/security data: short-lived unless needed for investigations

When no longer needed, we delete or de-identify data.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

7) COOKIES & TRACKING

We use minimal cookies for:
   • Session management, security, CSRF protection
   • Basic usage analytics (page views, errors)
   • Remembering preferences

Controls: Adjust browser settings to block/clear cookies. Blocking required cookies may break site features.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

8) SECURITY

We implement administrative, technical, and physical safeguards:
   • HTTPS/TLS encryption in transit
   • Restricted data access; role-based permissions
   • Password hygiene; MFA where possible
   • Regular updates and security patches
   • Provider compliance (e.g., Stripe PCI-DSS)

No system is 100% secure. Promptly notify us of suspected unauthorized activity.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

9) YOUR PRIVACY CHOICES & RIGHTS

9.1 Email/SMS Preferences:
   • Email: use unsubscribe links or contact us
   • SMS: reply STOP to opt out of marketing

9.2 Access, Correction, Deletion:
   • Access/portability: copy of your Personal Information
   • Correction: fix inaccurate data
   • Deletion: remove data we no longer need

Submit requests to: legal@awpressurewash.com

9.3 State-Specific Rights (U.S.):
Depending on your state (CA, CO, CT, UT, VA, etc.), you may have rights to access, correct, delete, and opt out. We do NOT sell Personal Information. Contact us to exercise state rights.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

10) CHILDREN'S PRIVACY

Our services are for adults. We do not knowingly collect information from children under 13. If you believe a child provided personal information, contact us for deletion.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

11) INTERNATIONAL VISITORS

Our data centers are in the UNITED STATES. If accessing from outside the U.S., your information may be processed here, where laws may differ. By using our services, you consent to this processing.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

12) SMS DISCLOSURE

By opting in, you agree to receive texts for estimates, scheduling, reminders, and (optionally) promotions. Message/data rates may apply. Reply STOP to opt out of marketing (service texts may continue). We do not sell your phone number.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

13) CHANGES TO THIS POLICY

We may update this Policy to reflect service changes or legal requirements. The "Last updated" date will change. Material changes will include additional notice where required.

Questions? Contact: legal@awpressurewash.com | (931) 259-7963`;

  const smsContent = `A&W PRESSURE WASHING & CLEANING - SMS PRIVACY POLICY
Last updated: August 5, 2026

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

1) OPT-IN & CONSENT

By providing your cell phone number and opting into our SMS program, you consent to receive text messages from A & W Pressure Washing & Cleaning for:
   • Service estimates and quotes
   • Appointment scheduling and confirmations
   • Service reminders and updates
   • Job completion notifications
   • Follow-up communications
   • Optional promotional offers (if selected)

Consent is voluntary. You are not required to opt in to use our website or services, except to receive SMS communications.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

2) FREQUENCY & MESSAGE RATES

   • FREQUENCY: Messages vary based on your service requests. You may receive 1–10+ messages per month depending on activity.

   • MESSAGE & DATA RATES: Standard message and data rates from your carrier may apply. We are not responsible for carrier charges. Check with your provider for details.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

3) HOW TO OPT OUT / UNSUBSCRIBE

   • REPLY "STOP": Reply STOP to any text to unsubscribe from ALL SMS messages.

   • SERVICE TEXTS MAY CONTINUE: Transactional messages (e.g., appointment reminders) may continue after opt-out.

   • REPLY "HELP": For help or more information.

   • CONTACT US: Email legal@awpressurewash.com or call (931) 259-7963.

   • EFFECTIVE IMMEDIATELY: Opt-out effective immediately. Allow 2–3 messages for system processing.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

4) WHAT WE COLLECT

   • Your phone number
   • Your opt-in status and timestamp
   • Message delivery status (sent, delivered, failed, bounced)
   • Your responses (if any) to our messages
   • Associated service information (name, address, appointment details)

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

5) HOW WE USE YOUR INFORMATION

   • Send requested service communications
   • Confirm and reschedule appointments
   • Send optional marketing messages (with your consent only)
   • Improve service delivery and customer experience
   • Maintain compliance records
   • Prevent fraud and verify authorizations

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

6) WHO WE SHARE YOUR INFORMATION WITH

   • SMS SERVICE PROVIDER: Our SMS platform vendor processes messages.
   • SERVICE TEAM: Our scheduling and field teams manage appointments.
   • PAYMENT PROCESSORS: If SMS linked to billing.
   • LEGAL/COMPLIANCE: If required by law.

WE DO NOT SELL your phone number to third parties.
WE DO NOT SHARE your phone number with unaffiliated marketers.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

7) DATA RETENTION

   • PHONE NUMBERS & CONSENT RECORDS: Retained 7 years or until opt-out.
   • MESSAGE LOGS: Retained 1 year unless legally required longer.
   • AFTER OPT-OUT: Records retained for compliance and fraud prevention.
   • DELETION REQUEST: You can request deletion anytime.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

8) SECURITY

We protect your phone number and messages using:
   • Industry-standard encryption
   • Access controls and role-based permissions
   • Secure SMS platforms

If you suspect unauthorized access, contact us immediately at (931) 259-7963 or legal@awpressurewash.com.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

9) YOUR RIGHTS

   • OPT OUT ANYTIME: Reply STOP or contact us.
   • REQUEST INFORMATION: Reply HELP or email legal@awpressurewash.com.
   • REQUEST DELETION: Ask us to delete your phone number (subject to legal retention).
   • FILE COMPLAINT: Contact your carrier or FCC at fcc.gov/complaints.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

10) DISCLAIMER OF WARRANTIES & LIABILITY

   • DELIVERY NOT GUARANTEED: Messages may be delayed or fail due to carrier issues.
   • WE ARE NOT LIABLE: For missed messages, delays, or carrier problems.
   • CARRIER RESPONSIBILITY: Security and interception risks are the carrier's responsibility.
   • BY OPTING IN: You acknowledge and assume risks of SMS communication.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

11) COMPLIANCE

This SMS program complies with:
   • The Telephone Consumer Protection Act (TCPA)
   • Federal Communications Commission (FCC) regulations
   • Wireless carrier guidelines
   • Tennessee state law
   • Applicable local laws

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

12) GOVERNING LAW

This SMS Privacy Policy is governed by TENNESSEE law. Disputes arising from this program shall be resolved in Warren County, Tennessee state courts.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

13) CONTACT US

Questions about this SMS Privacy Policy:
   • Email: legal@awpressurewash.com
   • Phone: (931) 259-7963
   • Mail: A & W Pressure Washing & Cleaning, 185 Duggin Rd, McMinnville, TN 37110

We will respond within 10 business days.

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

ACKNOWLEDGMENT

By providing your phone number and clicking "Opt In," you acknowledge:
   ✓ You have read and understood this SMS Privacy Policy
   ✓ You agree to receive SMS communications
   ✓ Message/data rates may apply
   ✓ You accept the disclaimer of warranties and liability`;

  const getContent = () => {
    const contentMap = {
      Terms: termsContent,
      PrivacyPolicy: privacyContent,
      SMSPrivacyPolicy: smsContent
    };
    return contentMap[activeTab] || termsContent;
  };

  const getTabColor = (tabName) => {
    const colors = {
      Terms: '#DC143C',
      PrivacyPolicy: '#FFFFFF',
      SMSPrivacyPolicy: '#1E40AF'
    };
    return colors[tabName];
  };

  const getTextColor = (tabName) => {
    return tabName === 'PrivacyPolicy' ? '#000' : '#fff';
  };

  const tabs = [
    { id: 'Terms', label: 'Terms & Conditions' },
    { id: 'PrivacyPolicy', label: 'Privacy Policy' },
    { id: 'SMSPrivacyPolicy', label: 'SMS Privacy Policy' }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9f9f9', paddingTop: '80px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1a1a1a', marginBottom: '10px' }}>
            Legal Documents
          </h1>
          <p style={{ fontSize: '16px', color: '#666' }}>
            A & W Pressure Washing & Cleaning
          </p>
        </div>

        {/* Custom Tabs */}
        <div style={{ display: 'flex', gap: '4px', marginBottom: '4px', borderBottom: '2px solid #e0e0e0' }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                backgroundColor: activeTab === tab.id ? getTabColor(tab.id) : '#f5f5f5',
                color: activeTab === tab.id ? getTextColor(tab.id) : '#666',
                border: 'none',
                padding: '14px 24px',
                fontSize: '15px',
                fontWeight: activeTab === tab.id ? '600' : '500',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: 1,
                textAlign: 'center',
                borderRadius: activeTab === tab.id ? '6px 6px 0 0' : '0',
                outline: 'none',
                boxShadow: activeTab === tab.id ? '0 2px 8px rgba(0,0,0,0.1)' : 'none'
              }}
              onMouseEnter={(e) => {
                if (activeTab !== tab.id) {
                  e.target.style.backgroundColor = '#efefef';
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== tab.id) {
                  e.target.style.backgroundColor = '#f5f5f5';
                }
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content Area */}
        <div
          style={{
            backgroundColor: '#fafafa',
            borderRadius: '0 6px 6px 6px',
            padding: '32px',
            maxHeight: '75vh',
            overflowY: 'auto',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            lineHeight: '1.6',
            fontSize: '14px',
            color: '#333',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word'
          }}
        >
          {getContent()}
        </div>

        {/* Footer */}
        <div style={{ marginTop: '32px', textAlign: 'center', color: '#666', fontSize: '13px' }}>
          <p>
            Last Updated: August 5, 2026 | 
            {' '}<a 
              href="mailto:legal@awpressurewash.com"
              style={{ color: '#DC143C', textDecoration: 'none', fontWeight: '500' }}
            >
              Contact Us
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
